/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "//s.geilicdn.com/robot/pc/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _preact = __webpack_require__(1);
	
	var _util = __webpack_require__(3);
	
	var util = _interopRequireWildcard(_util);
	
	var _sdk = __webpack_require__(2);
	
	var _sdk2 = _interopRequireDefault(_sdk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var root = document.getElementById('app');
	
	function init() {
		var App = __webpack_require__(7).default;
	
		root = (0, _preact.render)((0, _preact.h)(App, null), document.body, root);
	}
	
	// 机器人 sid
	var DEFAULT_SERVICE_SID = '1139630945';
	
	// 获取用户信息
	var bid = util.getCookie('WD_b_id');
	var wduss = util.getCookie('WD_s_wduss');
	var sid = util.getCookie('WD_s_id');
	
	_sdk2.default.ready(DEFAULT_SERVICE_SID, wduss, sid, bid, function (err, data) {
		if (err) {
			return alert('信息获取错误，请刷新页面重试！');
		}
	
		init();
	});

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	!function(global, factory) {
	     true ? factory(exports) : 'function' == typeof define && define.amd ? define([ 'exports' ], factory) : factory(global.preact = global.preact || {});
	}(this, function(exports) {
	    function VNode(nodeName, attributes, children) {
	        this.nodeName = nodeName;
	        this.attributes = attributes;
	        this.children = children;
	        this.key = attributes && attributes.key;
	    }
	    function h(nodeName, attributes) {
	        var children, lastSimple, child, simple, i;
	        for (i = arguments.length; i-- > 2; ) stack.push(arguments[i]);
	        if (attributes && attributes.children) {
	            if (!stack.length) stack.push(attributes.children);
	            delete attributes.children;
	        }
	        while (stack.length) if ((child = stack.pop()) instanceof Array) for (i = child.length; i--; ) stack.push(child[i]); else if (null != child && child !== !0 && child !== !1) {
	            if ('number' == typeof child) child = String(child);
	            simple = 'string' == typeof child;
	            if (simple && lastSimple) children[children.length - 1] += child; else {
	                (children || (children = [])).push(child);
	                lastSimple = simple;
	            }
	        }
	        var p = new VNode(nodeName, attributes || void 0, children || EMPTY_CHILDREN);
	        if (options.vnode) options.vnode(p);
	        return p;
	    }
	    function extend(obj, props) {
	        if (props) for (var i in props) obj[i] = props[i];
	        return obj;
	    }
	    function clone(obj) {
	        return extend({}, obj);
	    }
	    function delve(obj, key) {
	        for (var p = key.split('.'), i = 0; i < p.length && obj; i++) obj = obj[p[i]];
	        return obj;
	    }
	    function isFunction(obj) {
	        return 'function' == typeof obj;
	    }
	    function isString(obj) {
	        return 'string' == typeof obj;
	    }
	    function hashToClassName(c) {
	        var str = '';
	        for (var prop in c) if (c[prop]) {
	            if (str) str += ' ';
	            str += prop;
	        }
	        return str;
	    }
	    function cloneElement(vnode, props) {
	        return h(vnode.nodeName, extend(clone(vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
	    }
	    function createLinkedState(component, key, eventPath) {
	        var path = key.split('.');
	        return function(e) {
	            var t = e && e.target || this, state = {}, obj = state, v = isString(eventPath) ? delve(e, eventPath) : t.nodeName ? t.type.match(/^che|rad/) ? t.checked : t.value : e, i = 0;
	            for (;i < path.length - 1; i++) obj = obj[path[i]] || (obj[path[i]] = !i && component.state[path[i]] || {});
	            obj[path[i]] = v;
	            component.setState(state);
	        };
	    }
	    function enqueueRender(component) {
	        if (!component._dirty && (component._dirty = !0) && 1 == items.push(component)) (options.debounceRendering || defer)(rerender);
	    }
	    function rerender() {
	        var p, list = items;
	        items = [];
	        while (p = list.pop()) if (p._dirty) renderComponent(p);
	    }
	    function isFunctionalComponent(vnode) {
	        var nodeName = vnode && vnode.nodeName;
	        return nodeName && isFunction(nodeName) && !(nodeName.prototype && nodeName.prototype.render);
	    }
	    function buildFunctionalComponent(vnode, context) {
	        return vnode.nodeName(getNodeProps(vnode), context || EMPTY);
	    }
	    function isSameNodeType(node, vnode) {
	        if (isString(vnode)) return node instanceof Text;
	        if (isString(vnode.nodeName)) return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
	        if (isFunction(vnode.nodeName)) return (node._componentConstructor ? node._componentConstructor === vnode.nodeName : !0) || isFunctionalComponent(vnode); else ;
	    }
	    function isNamedNode(node, nodeName) {
	        return node.normalizedNodeName === nodeName || toLowerCase(node.nodeName) === toLowerCase(nodeName);
	    }
	    function getNodeProps(vnode) {
	        var props = clone(vnode.attributes);
	        props.children = vnode.children;
	        var defaultProps = vnode.nodeName.defaultProps;
	        if (defaultProps) for (var i in defaultProps) if (void 0 === props[i]) props[i] = defaultProps[i];
	        return props;
	    }
	    function removeNode(node) {
	        var p = node.parentNode;
	        if (p) p.removeChild(node);
	    }
	    function setAccessor(node, name, old, value, isSvg) {
	        if ('className' === name) name = 'class';
	        if ('class' === name && value && 'object' == typeof value) value = hashToClassName(value);
	        if ('key' === name) ; else if ('class' === name && !isSvg) node.className = value || ''; else if ('style' === name) {
	            if (!value || isString(value) || isString(old)) node.style.cssText = value || '';
	            if (value && 'object' == typeof value) {
	                if (!isString(old)) for (var i in old) if (!(i in value)) node.style[i] = '';
	                for (var i in value) node.style[i] = 'number' == typeof value[i] && !NON_DIMENSION_PROPS[i] ? value[i] + 'px' : value[i];
	            }
	        } else if ('dangerouslySetInnerHTML' === name) {
	            if (value) node.innerHTML = value.__html || '';
	        } else if ('o' == name[0] && 'n' == name[1]) {
	            var l = node._listeners || (node._listeners = {});
	            name = toLowerCase(name.substring(2));
	            if (value) {
	                if (!l[name]) node.addEventListener(name, eventProxy, !!NON_BUBBLING_EVENTS[name]);
	            } else if (l[name]) node.removeEventListener(name, eventProxy, !!NON_BUBBLING_EVENTS[name]);
	            l[name] = value;
	        } else if ('list' !== name && 'type' !== name && !isSvg && name in node) {
	            setProperty(node, name, null == value ? '' : value);
	            if (null == value || value === !1) node.removeAttribute(name);
	        } else {
	            var ns = isSvg && name.match(/^xlink\:?(.+)/);
	            if (null == value || value === !1) if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', toLowerCase(ns[1])); else node.removeAttribute(name); else if ('object' != typeof value && !isFunction(value)) if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', toLowerCase(ns[1]), value); else node.setAttribute(name, value);
	        }
	    }
	    function setProperty(node, name, value) {
	        try {
	            node[name] = value;
	        } catch (e) {}
	    }
	    function eventProxy(e) {
	        return this._listeners[e.type](options.event && options.event(e) || e);
	    }
	    function collectNode(node) {
	        removeNode(node);
	        if (node instanceof Element) {
	            node._component = node._componentConstructor = null;
	            var _name = node.normalizedNodeName || toLowerCase(node.nodeName);
	            (nodes[_name] || (nodes[_name] = [])).push(node);
	        }
	    }
	    function createNode(nodeName, isSvg) {
	        var name = toLowerCase(nodeName), node = nodes[name] && nodes[name].pop() || (isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName));
	        node.normalizedNodeName = name;
	        return node;
	    }
	    function flushMounts() {
	        var c;
	        while (c = mounts.pop()) {
	            if (options.afterMount) options.afterMount(c);
	            if (c.componentDidMount) c.componentDidMount();
	        }
	    }
	    function diff(dom, vnode, context, mountAll, parent, componentRoot) {
	        if (!diffLevel++) {
	            isSvgMode = parent && 'undefined' != typeof parent.ownerSVGElement;
	            hydrating = dom && !(ATTR_KEY in dom);
	        }
	        var ret = idiff(dom, vnode, context, mountAll);
	        if (parent && ret.parentNode !== parent) parent.appendChild(ret);
	        if (!--diffLevel) {
	            hydrating = !1;
	            if (!componentRoot) flushMounts();
	        }
	        return ret;
	    }
	    function idiff(dom, vnode, context, mountAll) {
	        var ref = vnode && vnode.attributes && vnode.attributes.ref;
	        while (isFunctionalComponent(vnode)) vnode = buildFunctionalComponent(vnode, context);
	        if (null == vnode) vnode = '';
	        if (isString(vnode)) {
	            if (dom && dom instanceof Text && dom.parentNode) {
	                if (dom.nodeValue != vnode) dom.nodeValue = vnode;
	            } else {
	                if (dom) recollectNodeTree(dom);
	                dom = document.createTextNode(vnode);
	            }
	            return dom;
	        }
	        if (isFunction(vnode.nodeName)) return buildComponentFromVNode(dom, vnode, context, mountAll);
	        var out = dom, nodeName = String(vnode.nodeName), prevSvgMode = isSvgMode, vchildren = vnode.children;
	        isSvgMode = 'svg' === nodeName ? !0 : 'foreignObject' === nodeName ? !1 : isSvgMode;
	        if (!dom) out = createNode(nodeName, isSvgMode); else if (!isNamedNode(dom, nodeName)) {
	            out = createNode(nodeName, isSvgMode);
	            while (dom.firstChild) out.appendChild(dom.firstChild);
	            if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
	            recollectNodeTree(dom);
	        }
	        var fc = out.firstChild, props = out[ATTR_KEY];
	        if (!props) {
	            out[ATTR_KEY] = props = {};
	            for (var a = out.attributes, i = a.length; i--; ) props[a[i].name] = a[i].value;
	        }
	        if (!hydrating && vchildren && 1 === vchildren.length && 'string' == typeof vchildren[0] && fc && fc instanceof Text && !fc.nextSibling) {
	            if (fc.nodeValue != vchildren[0]) fc.nodeValue = vchildren[0];
	        } else if (vchildren && vchildren.length || fc) innerDiffNode(out, vchildren, context, mountAll, !!props.dangerouslySetInnerHTML);
	        diffAttributes(out, vnode.attributes, props);
	        if (ref) (props.ref = ref)(out);
	        isSvgMode = prevSvgMode;
	        return out;
	    }
	    function innerDiffNode(dom, vchildren, context, mountAll, absorb) {
	        var j, c, vchild, child, originalChildren = dom.childNodes, children = [], keyed = {}, keyedLen = 0, min = 0, len = originalChildren.length, childrenLen = 0, vlen = vchildren && vchildren.length;
	        if (len) for (var i = 0; i < len; i++) {
	            var _child = originalChildren[i], props = _child[ATTR_KEY], key = vlen ? (c = _child._component) ? c.__key : props ? props.key : null : null;
	            if (null != key) {
	                keyedLen++;
	                keyed[key] = _child;
	            } else if (hydrating || absorb || props || _child instanceof Text) children[childrenLen++] = _child;
	        }
	        if (vlen) for (var i = 0; i < vlen; i++) {
	            vchild = vchildren[i];
	            child = null;
	            var key = vchild.key;
	            if (null != key) {
	                if (keyedLen && key in keyed) {
	                    child = keyed[key];
	                    keyed[key] = void 0;
	                    keyedLen--;
	                }
	            } else if (!child && min < childrenLen) for (j = min; j < childrenLen; j++) {
	                c = children[j];
	                if (c && isSameNodeType(c, vchild)) {
	                    child = c;
	                    children[j] = void 0;
	                    if (j === childrenLen - 1) childrenLen--;
	                    if (j === min) min++;
	                    break;
	                }
	            }
	            child = idiff(child, vchild, context, mountAll);
	            if (child && child !== dom) if (i >= len) dom.appendChild(child); else if (child !== originalChildren[i]) {
	                if (child === originalChildren[i + 1]) removeNode(originalChildren[i]);
	                dom.insertBefore(child, originalChildren[i] || null);
	            }
	        }
	        if (keyedLen) for (var i in keyed) if (keyed[i]) recollectNodeTree(keyed[i]);
	        while (min <= childrenLen) {
	            child = children[childrenLen--];
	            if (child) recollectNodeTree(child);
	        }
	    }
	    function recollectNodeTree(node, unmountOnly) {
	        var component = node._component;
	        if (component) unmountComponent(component, !unmountOnly); else {
	            if (node[ATTR_KEY] && node[ATTR_KEY].ref) node[ATTR_KEY].ref(null);
	            if (!unmountOnly) collectNode(node);
	            var c;
	            while (c = node.lastChild) recollectNodeTree(c, unmountOnly);
	        }
	    }
	    function diffAttributes(dom, attrs, old) {
	        var name;
	        for (name in old) if (!(attrs && name in attrs) && null != old[name]) setAccessor(dom, name, old[name], old[name] = void 0, isSvgMode);
	        if (attrs) for (name in attrs) if (!('children' === name || 'innerHTML' === name || name in old && attrs[name] === ('value' === name || 'checked' === name ? dom[name] : old[name]))) setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
	    }
	    function collectComponent(component) {
	        var name = component.constructor.name, list = components[name];
	        if (list) list.push(component); else components[name] = [ component ];
	    }
	    function createComponent(Ctor, props, context) {
	        var inst = new Ctor(props, context), list = components[Ctor.name];
	        Component.call(inst, props, context);
	        if (list) for (var i = list.length; i--; ) if (list[i].constructor === Ctor) {
	            inst.nextBase = list[i].nextBase;
	            list.splice(i, 1);
	            break;
	        }
	        return inst;
	    }
	    function setComponentProps(component, props, opts, context, mountAll) {
	        if (!component._disable) {
	            component._disable = !0;
	            if (component.__ref = props.ref) delete props.ref;
	            if (component.__key = props.key) delete props.key;
	            if (!component.base || mountAll) {
	                if (component.componentWillMount) component.componentWillMount();
	            } else if (component.componentWillReceiveProps) component.componentWillReceiveProps(props, context);
	            if (context && context !== component.context) {
	                if (!component.prevContext) component.prevContext = component.context;
	                component.context = context;
	            }
	            if (!component.prevProps) component.prevProps = component.props;
	            component.props = props;
	            component._disable = !1;
	            if (0 !== opts) if (1 === opts || options.syncComponentUpdates !== !1 || !component.base) renderComponent(component, 1, mountAll); else enqueueRender(component);
	            if (component.__ref) component.__ref(component);
	        }
	    }
	    function renderComponent(component, opts, mountAll, isChild) {
	        if (!component._disable) {
	            var skip, rendered, inst, cbase, props = component.props, state = component.state, context = component.context, previousProps = component.prevProps || props, previousState = component.prevState || state, previousContext = component.prevContext || context, isUpdate = component.base, nextBase = component.nextBase, initialBase = isUpdate || nextBase, initialChildComponent = component._component;
	            if (isUpdate) {
	                component.props = previousProps;
	                component.state = previousState;
	                component.context = previousContext;
	                if (2 !== opts && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === !1) skip = !0; else if (component.componentWillUpdate) component.componentWillUpdate(props, state, context);
	                component.props = props;
	                component.state = state;
	                component.context = context;
	            }
	            component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
	            component._dirty = !1;
	            if (!skip) {
	                if (component.render) rendered = component.render(props, state, context);
	                if (component.getChildContext) context = extend(clone(context), component.getChildContext());
	                while (isFunctionalComponent(rendered)) rendered = buildFunctionalComponent(rendered, context);
	                var toUnmount, base, childComponent = rendered && rendered.nodeName;
	                if (isFunction(childComponent)) {
	                    var childProps = getNodeProps(rendered);
	                    inst = initialChildComponent;
	                    if (inst && inst.constructor === childComponent && childProps.key == inst.__key) setComponentProps(inst, childProps, 1, context); else {
	                        toUnmount = inst;
	                        inst = createComponent(childComponent, childProps, context);
	                        inst.nextBase = inst.nextBase || nextBase;
	                        inst._parentComponent = component;
	                        component._component = inst;
	                        setComponentProps(inst, childProps, 0, context);
	                        renderComponent(inst, 1, mountAll, !0);
	                    }
	                    base = inst.base;
	                } else {
	                    cbase = initialBase;
	                    toUnmount = initialChildComponent;
	                    if (toUnmount) cbase = component._component = null;
	                    if (initialBase || 1 === opts) {
	                        if (cbase) cbase._component = null;
	                        base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, !0);
	                    }
	                }
	                if (initialBase && base !== initialBase && inst !== initialChildComponent) {
	                    var baseParent = initialBase.parentNode;
	                    if (baseParent && base !== baseParent) {
	                        baseParent.replaceChild(base, initialBase);
	                        if (!toUnmount) {
	                            initialBase._component = null;
	                            recollectNodeTree(initialBase);
	                        }
	                    }
	                }
	                if (toUnmount) unmountComponent(toUnmount, base !== initialBase);
	                component.base = base;
	                if (base && !isChild) {
	                    var componentRef = component, t = component;
	                    while (t = t._parentComponent) (componentRef = t).base = base;
	                    base._component = componentRef;
	                    base._componentConstructor = componentRef.constructor;
	                }
	            }
	            if (!isUpdate || mountAll) mounts.unshift(component); else if (!skip) {
	                if (component.componentDidUpdate) component.componentDidUpdate(previousProps, previousState, previousContext);
	                if (options.afterUpdate) options.afterUpdate(component);
	            }
	            var fn, cb = component._renderCallbacks;
	            if (cb) while (fn = cb.pop()) fn.call(component);
	            if (!diffLevel && !isChild) flushMounts();
	        }
	    }
	    function buildComponentFromVNode(dom, vnode, context, mountAll) {
	        var c = dom && dom._component, originalComponent = c, oldDom = dom, isDirectOwner = c && dom._componentConstructor === vnode.nodeName, isOwner = isDirectOwner, props = getNodeProps(vnode);
	        while (c && !isOwner && (c = c._parentComponent)) isOwner = c.constructor === vnode.nodeName;
	        if (c && isOwner && (!mountAll || c._component)) {
	            setComponentProps(c, props, 3, context, mountAll);
	            dom = c.base;
	        } else {
	            if (originalComponent && !isDirectOwner) {
	                unmountComponent(originalComponent, !0);
	                dom = oldDom = null;
	            }
	            c = createComponent(vnode.nodeName, props, context);
	            if (dom && !c.nextBase) {
	                c.nextBase = dom;
	                oldDom = null;
	            }
	            setComponentProps(c, props, 1, context, mountAll);
	            dom = c.base;
	            if (oldDom && dom !== oldDom) {
	                oldDom._component = null;
	                recollectNodeTree(oldDom);
	            }
	        }
	        return dom;
	    }
	    function unmountComponent(component, remove) {
	        if (options.beforeUnmount) options.beforeUnmount(component);
	        var base = component.base;
	        component._disable = !0;
	        if (component.componentWillUnmount) component.componentWillUnmount();
	        component.base = null;
	        var inner = component._component;
	        if (inner) unmountComponent(inner, remove); else if (base) {
	            if (base[ATTR_KEY] && base[ATTR_KEY].ref) base[ATTR_KEY].ref(null);
	            component.nextBase = base;
	            if (remove) {
	                removeNode(base);
	                collectComponent(component);
	            }
	            var c;
	            while (c = base.lastChild) recollectNodeTree(c, !remove);
	        }
	        if (component.__ref) component.__ref(null);
	        if (component.componentDidUnmount) component.componentDidUnmount();
	    }
	    function Component(props, context) {
	        this._dirty = !0;
	        this.context = context;
	        this.props = props;
	        if (!this.state) this.state = {};
	    }
	    function render(vnode, parent, merge) {
	        return diff(merge, vnode, {}, !1, parent);
	    }
	    var options = {};
	    var stack = [];
	    var EMPTY_CHILDREN = [];
	    var lcCache = {};
	    var toLowerCase = function(s) {
	        return lcCache[s] || (lcCache[s] = s.toLowerCase());
	    };
	    var resolved = 'undefined' != typeof Promise && Promise.resolve();
	    var defer = resolved ? function(f) {
	        resolved.then(f);
	    } : setTimeout;
	    var EMPTY = {};
	    var ATTR_KEY = 'undefined' != typeof Symbol ? Symbol.for('preactattr') : '__preactattr_';
	    var NON_DIMENSION_PROPS = {
	        boxFlex: 1,
	        boxFlexGroup: 1,
	        columnCount: 1,
	        fillOpacity: 1,
	        flex: 1,
	        flexGrow: 1,
	        flexPositive: 1,
	        flexShrink: 1,
	        flexNegative: 1,
	        fontWeight: 1,
	        lineClamp: 1,
	        lineHeight: 1,
	        opacity: 1,
	        order: 1,
	        orphans: 1,
	        strokeOpacity: 1,
	        widows: 1,
	        zIndex: 1,
	        zoom: 1
	    };
	    var NON_BUBBLING_EVENTS = {
	        blur: 1,
	        error: 1,
	        focus: 1,
	        load: 1,
	        resize: 1,
	        scroll: 1
	    };
	    var items = [];
	    var nodes = {};
	    var mounts = [];
	    var diffLevel = 0;
	    var isSvgMode = !1;
	    var hydrating = !1;
	    var components = {};
	    extend(Component.prototype, {
	        linkState: function(key, eventPath) {
	            var c = this._linkedStates || (this._linkedStates = {});
	            return c[key + eventPath] || (c[key + eventPath] = createLinkedState(this, key, eventPath));
	        },
	        setState: function(state, callback) {
	            var s = this.state;
	            if (!this.prevState) this.prevState = clone(s);
	            extend(s, isFunction(state) ? state(s, this.props) : state);
	            if (callback) (this._renderCallbacks = this._renderCallbacks || []).push(callback);
	            enqueueRender(this);
	        },
	        forceUpdate: function() {
	            renderComponent(this, 2);
	        },
	        render: function() {}
	    });
	    exports.h = h;
	    exports.cloneElement = cloneElement;
	    exports.Component = Component;
	    exports.render = render;
	    exports.rerender = rerender;
	    exports.options = options;
	});


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _request = __webpack_require__(15);
	
	var _request2 = _interopRequireDefault(_request);
	
	var _request3 = __webpack_require__(6);
	
	var _queryString = __webpack_require__(31);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _events = __webpack_require__(29);
	
	var _util = __webpack_require__(3);
	
	var util = _interopRequireWildcard(_util);
	
	var _workTime = __webpack_require__(17);
	
	var workTime = _interopRequireWildcard(_workTime);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * sdk 提供需要的接口
	 */
	workTime.ajustTime();
	
	var sessionId = util.getSessionId();
	
	var Event = new _events.EventEmitter();
	
	// 默认欢迎语
	var _welcome = '您好，请简单、清晰的描述问题，小微帮您解决 [愉快]';
	
	// 用户信息
	var _sessions = {};
	// 机器人 sid
	var _robotSid = '';
	// 用户 sid
	var _accoutSid = '';
	// 用户 bid
	var _accoutBid = '';
	// 人工客服地址
	var _staffServiceUrl = '';
	// 通道
	var _channel = '';
	// 来源
	var _sourceType = 'cellerPc';
	
	// 消息列表
	var _msgList = [];
	
	/**
	 * 获取用户信息
	 * @param {*} sid
	 */
	function getSession(sid) {
		return _sessions[sid];
	}
	
	/**
	 * 获取入口场景值
	 * @param {*} sourceType
	 */
	function getQueueId(sourceType) {
		var map = {
			buyerApp: 103,
			buyerH5: 102,
			sellerPc: 100,
			sellerApp: 101
		};
	
		return map[sourceType];
	}
	
	/**
	 * 获取消息列表
	 */
	function getMsgList() {
		return _msgList;
	}
	
	/**
	 * 往 _msgList 添加消息
	 * @param {*} msg
	 */
	function addMsgItem(msg) {
		_msgList.push(msg);
	}
	
	/**
	 * 推入发送消息
	 * @param {*} content
	 */
	function appendMsg(content) {
		var msg = createMsg(content, _accoutSid, 'send');
	
		addMsgItem(msg);
	
		Event.emit('msgChange', msg);
	}
	
	function mockRobotSend(content) {
		var msg = createMsg(content, _robotSid, 'receive');
		addMsgItem(msg);
		Event.emit('msgChange', msg);
	}
	
	/**
	 * 发送消息到服务器
	 * @param {*} msg
	 * @param {*} fn
	 */
	function send(msg, fn) {
		if (msg.indexOf('人工') !== -1) {
			var msgR = createMsg('', _robotSid, 'receive');
			msgR.overturn = 1;
	
			addMsgItem(msgR);
			Event.emit('msgChange', msgR);
			return fn(null, { status_code: 0 });
		}
	
		(0, _request2.default)('sendMessage', {
			bid: _accoutBid,
			question: msg,
			channel: _channel,
			sourceType: _sourceType
		}, function (err, response) {
			if (err) {
				return fn && fn(err, null);
			}
	
			// _channel
			if (response.status.status_code === 0) {
				fn && fn(null, response.status);
	
				var _msg = createReceiveMsg(response.result);
	
				addMsgItem(_msg);
				Event.emit('msgChange', _msg);
			}
		});
	}
	
	/**
	 * 发送反馈到服务器
	 * @param {*} msgId
	 * @param {*} feedBackValue
	 */
	function feedBack(msgId, feedBackValue) {
		(0, _request2.default)('sendFeedBack', {
			bid: _accoutBid,
			msgId: msgId,
			channel: _channel,
			result: feedBackValue,
			sourceType: _sourceType
		}, function (err, response) {
			console.log('feedBack err');
		});
	}
	
	function createReceiveMsg(data) {
		var session = getSession(_robotSid);
	
		// 从无到有时上报渠道
		if (!_channel && window.spider) {
			window.spider.trackAction({
				actionName: "自助客服聊天页-渠道分配",
				actionArgs: {
					"sourceType": _sourceType || 'sellerPC',
					"channel": data.channel,
					sessionId: sessionId
				}
			});
		}
	
		_channel = data.channel || _channel;
	
		var detail = {
			similarQuestion: []
		};
	
		try {
			detail.similarQuestion = JSON.parse(data.similarQuestion);
	
			if (!Array.isArray(detail.similarQuestion)) {
				throw data.similarQuestion;
			}
		} catch (error) {
			console.log('相似问题解析出错', data.similarQuestion, error);
		}
	
		return {
			session: session,
			detail: detail,
			msgData: data.answer,
			msgId: data.feedbackId,
			time: data.time || +new Date(),
			needFeedback: data.needFeedback,
			overturn: data.overturn,
			role: 'receive',
			isStorage: true
		};
	}
	
	function createMsg(msg, sid, role) {
		var session = getSession(sid);
	
		return {
			session: session,
	
			detail: {
				similarQuestion: []
			},
	
			msgData: msg,
			msgId: Date.now(),
			time: Date.now(),
			needFeedback: 0,
			overturn: 0,
			role: role,
			isStorage: role !== 'send' //是否入库
		};
	}
	
	function onMsgChange(fn) {
		Event.on('msgChange', fn);
	}
	
	function ready(robotSid, wduss, sid, bid, fn) {
		var search = _queryString2.default.parse(window.location.search);
	
		// 私有变量缓存数据
		_robotSid = robotSid;
		_accoutSid = sid;
		_accoutBid = bid;
		_sourceType = search.sourceType || 'sellerPc';
	
		if (window.spider) {
			window.spider.trackAction({
				actionName: "自助客服聊天页-进入页面",
				actionArgs: {
					"sourceType": _sourceType || 'sellerPC',
					"channel": _channel,
					sessionId: sessionId
				}
			});
		}
		getOnlineServerUrl(sid, wduss, bid);
	
		(0, _request2.default)('getUserInfo', {
			sids: [sid, robotSid].join(','),
			sid: sid,
			bid: bid
		}, function (err, response) {
			if (err) {
				return fn && fn(err, null);
			}
	
			if (response.status && response.status.status_code === 0) {
				var data = response.result;
	
				for (var key in data) {
					var info = data[key];
	
					_sessions[key] = {
						exInfo: info.exInfo,
						portrait: info.headimg, // 头像
						nickname: info.name, // 昵称
						uid: info.uid, // uid
						sid: info.sid, // sid
						userId: info.sid === sid ? bid : info.sid
					};
				}
	
				// 欢迎语
				var msg = createMsg(_welcome, _robotSid, 'receive');
				// 添加到第一条消息
				addMsgItem(msg);
	
				fn && fn(null, _sessions);
			} else {
				fn && fn(new Error('请求错误'), null);
			}
		});
	}
	
	function gotoStaffService() {
		if (_staffServiceUrl) {
			var search = _queryString2.default.parse(window.location.search);
	
			if (!workTime.isSpringWorkTime()) {
				mockRobotSend('【系统消息】2月9日至2月21日春节期间，微店人工在线客服服务时间：09：00-18：00。如需咨询，建议您在工作时间联系客服，感谢您的理解。');
				return;
			}
			if (!workTime.isDouble11WorkTime()) {
	
				mockRobotSend('【系统消息】微店人工在线客服服务时间：09:00-次日2:00。如需咨询，建议您在工作时间联系客服，感谢您的理解。');
				return;
			}
	
			if (!workTime.isSpringFestival() && !workTime.isDouble11() && !workTime.isWorkTime()) {
				// 非工作时间点人工
				mockRobotSend('【系统消息】微店人工在线客服服务时间：09:00-21:00。如需咨询，建议您在工作时间联系客服，感谢您的理解。');
				return;
			}
	
			if (window.spider) {
				window.spider.trackAction({
					actionName: "自助客服聊天页-人工客服",
					actionArgs: {
						"sourceType": _sourceType || 'sellerPC',
						"channel": _channel,
						sessionId: sessionId
					}
				});
			}
	
			window.open(_staffServiceUrl, '_blank');
		}
	}
	
	// uid 是传值 bid
	function getOnlineServerUrl(userID, wduss, uid, fn) {
		(0, _request2.default)('getTicket', uid, function (err, _ref) {
			var result = _ref.result,
			    status = _ref.status;
	
			if (status && status.status_code === "0") {
				var baseUrl = _request3.STAFF_SERVICE;
				var search = _queryString2.default.parse(window.location.search);
				var queueId = getQueueId(search.sourceType || 'sellerPc'); // 默认卖家 app 兼容老地址
	
				_staffServiceUrl = baseUrl + '?ticketuid=' + uid + '&ticket=' + result.ticket + '&sellerId=' + uid + '&queue=' + queueId;
				console.log(_staffServiceUrl);
			}
		});
	
		setTimeout(function () {
			getOnlineServerUrl(userID, wduss, uid);
		}, 4 * 60 * 1000); // 5分钟ticket过期但写成4分钟
	}
	
	exports.default = {
		ready: ready,
		getSession: getSession,
		getMsgList: getMsgList,
		appendMsg: appendMsg,
		onMsgChange: onMsgChange,
		send: send,
		feedBack: feedBack,
		getOnlineServerUrl: getOnlineServerUrl,
		gotoStaffService: gotoStaffService
	};

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * 工具库
	 */
	
	/**
	 * 生成随机数
	 */
	function _randomWord(randomFlag, min, max) {
		var str = "",
		    range = min,
		    arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
	
		// 随机产生
		if (randomFlag) {
			range = Math.round(Math.random() * (max - min)) + min;
		}
	
		for (var i = 0; i < range; i++) {
			var pos = Math.round(Math.random() * (arr.length - 1));
			str += arr[pos];
		}
	
		return str;
	}
	
	/**
	 * 创建获取随机数的方法的方法
	 * @param {number} num 随机数位数
	 * @returns {function}
	 */
	function _createSessionId(num) {
		var _sessionId = '';
	
		return function () {
			if (!_sessionId) {
				_sessionId = _randomWord(false, num);
			}
	
			return _sessionId;
		};
	}
	
	// 获取随机数
	var getSessionId = _createSessionId(32);
	
	function delCookie(name) {
		var path_domain = "; path=/; domain=weidian.com";
		if (document.domain.indexOf('koudai.com') !== -1) {
			path_domain = "; path=/; domain=koudai.com";
		}
		document.cookie = name + "=; expires=" + new Date(0).toUTCString() + path_domain;
	}
	
	function getCookie(name) {
		var cookie_start = document.cookie.indexOf(name + "="),
		    cookie_end = document.cookie.indexOf(";", cookie_start);
		return cookie_start == -1 ? "" : document.cookie.substring(cookie_start + name.length + 1, cookie_end > cookie_start ? cookie_end : document.cookie.length);
	}
	
	/**
	 *   isSession 标识cookie是否在关闭浏览器后清除,默认有效期一个月
	 *   $.setCookie(key, value, isSession)
	 *
	 *   $.setCookie({key1:value1, key2:value2}, isSession)
	 *
	 */
	function setCookie(name, value, isSession) {
		var expires = new Date();
		expires.setTime(expires.getTime() + 2592000000); //1month
		var path_domain = "; path=/" + (document.domain.indexOf("vdian.com") != -1 ? "; domain=vdian.com" : document.domain.indexOf("koudai.com") != -1 ? "; domain=koudai.com" : document.domain.indexOf("weidian.com") != -1 ? "; domain=weidian.com" : "");
		if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === "object") {
			for (var v in name) {
				if (name[v] != '' || name[v] === 0 || name[v].length) {
					//如果值为空，就不设置cookie
					console.log(Number(name[v]) + '_' + name[v].length);
					//console.log(name[v].length)
					var cookie_content = escape(v) + "=" + escape(name[v]);
					document.cookie = cookie_content + "; expires=" + expires.toGMTString() + path_domain;
				}
			}
		} else {
			if (value != '' || value === 0 || value.length) {
				////如果值为空，就不设置cookie
				var cookie_content = escape(name) + "=" + escape(value);
				document.cookie = cookie_content + (isSession ? "" : "; expires=" + expires.toGMTString()) + path_domain;
			}
		}
	}
	
	function formatTime(s) {
		var arr = s.split(" ");
		var date = arr[0].split("-");
		var time = arr[1].split(":");
		var y = date[0];
		var m = date[1];
		var d = date[2];
		var _string = new Date();
		var _y = _string.getFullYear();
		var _m = _string.getMonth() + 1;
		var _d = _string.getDate();
		if (y == _y && m == _m && d == _d) {
			var _hours = Number(time[0]);
			var _hours_str = _hours < 12 ? _hours < 6 ? "凌晨 " + _hours : "上午 " + _hours : _hours > 12 ? _hours >= 18 ? "晚上 " + (_hours - 12) : "下午 " + (_hours - 12) : "中午 12";
			return _hours_str + ":" + time[1];
		} else {
			//console.log("不是同一天发的 直接显示 "+ y.toString().substring(2) +"-"+ m +"-"+ d);
			return y.toString().substring(2) + "-" + m + "-" + d;
		}
	}
	
	function getLocalTime(tm) {
		var tm = tm - 0;
		var da = tm;
		da = new Date(da);
		var year = da.getFullYear();
		var month = da.getMonth() + 1;
		var date = da.getDate();
		var h = da.getHours();
		var m = da.getMinutes();
		var s = da.getSeconds();
		var datatime = year + '-' + month + '-' + date + ' ' + h + ':' + (m * 1 >= 10 ? m : "0" + m * 1) + ':' + s;
		return formatTime(datatime);
	}
	
	// 解析表情 parseFace :: (Object, string) -> string
	function parseFace(faceMap, msg) {
		msg = msg.replace(/(\[.*?\])/g, function (face) {
			if (faceMap[face]) {
				return '<img src="' + faceMap[face] + '" alt="' + face + '" width="24" height="24"/>';
			} else {
				return face;
			}
		});
	
		return msg;
	}
	
	exports.getSessionId = getSessionId;
	exports.getCookie = getCookie;
	exports.setCookie = setCookie;
	exports.delCookie = delCookie;
	exports.getLocalTime = getLocalTime;
	exports.parseFace = parseFace;

/***/ },
/* 4 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var base = "https://s.geilicdn.com/im/emoji/kb-emoji-";
	var ext = ".png";
	function com(name) {
	  return base + name + ext;
	}
	exports.default = {
	  "[微笑]": com("E056"),
	  "[愉快]": com("E056"),
	  "[呲牙]": com("E404"),
	  "[惊讶]": com("E107"),
	  "[色]": com("E106"),
	  "[流汗]": com("E108"),
	  "[飞吻]": com("E418"),
	  "[流泪]": com("E411"),
	  "[亲亲]": com("E417"),
	  "[难过]": com("E413"),
	  "[惬意]": com("E40A"),
	  "[得意]": com("E402"),
	  "[笑哭]": com("E412"),
	  "[吐舌]": com("E409"),
	  "[发呆]": com("E40D"),
	  "[生气]": com("E059"),
	  "[失落]": com("E403"),
	  "[傻笑]": com("E415"),
	  "[淘气]": com("E105"),
	  "[害羞]": com("E414"),
	  "[眨眼]": com("E405"),
	  "[笑脸]": com("E057"),
	  "[眼花]": com("E410"),
	  "[委屈]": com("E058"),
	  "[抓狂]": com("E407"),
	  "[鄙视]": com("E40E"),
	  "[生病]": com("E40C"),
	  "[困了]": com("E408"),
	  "[震惊]": com("E40B"),
	  "[冷汗]": com("E40F"),
	  "[愤怒]": com("E416"),
	  "[邪恶]": com("E11A"),
	  "[晚安]": com("E13C"),
	  "[土豪]": com("E12F"),
	  "[酷]": com("E214"),
	  "[玫瑰]": com("E032"),
	  "[嘴唇]": com("E003"),
	  "[眼睛]": com("E419"),
	  "[赞]": com("E00E"),
	  "[ok]": com("E420"),
	  "[胜利]": com("E011"),
	  "[鼓掌]": com("E41F"),
	  "[双手赞成]": com("E427"),
	  "[双手合十]": com("E41D"),
	  "[便便]": com("E05A"),
	  "[心]": com("E022"),
	  "[心碎]": com("E023"),
	  "[丘比特]": com("E329"),
	  "[爱心]": com("E327"),
	  "[心动]": com("E328"),
	  "[叹号]": com("E337"),
	  "[疑问]": com("E336"),
	  "[闪烁]": com("E32E"),
	  "[星星]": com("E335"),
	  "[水滴]": com("E331"),
	  "[火]": com("E11D"),
	  "[爱情]": com("E111"),
	  "[牵手]": com("E428"),
	  "[起来嗨]": com("E51F"),
	  "[跳舞]": com("E429"),
	  "[钻石]": com("E035"),
	  "[干杯]": com("E30C"),
	  "[咖啡]": com("E045"),
	  "[礼盒]": com("E437"),
	  "[鬼脸]": com("E11B"),
	  "[圣诞老人]": com("E448"),
	  "[圣诞树]": com("E033"),
	  "[礼物]": com("E112"),
	  "[庆祝]": com("E312"),
	  "[气球]": com("E310"),
	  "[唱歌]": com("E03C"),
	  "[比基尼]": com("E322"),
	  "[冰激凌]": com("E33A"),
	  "[蛋糕]": com("E34B"),
	  "[流星]": com("E44B"),
	  "[焰火]": com("E117"),
	  "[彩虹]": com("E44C"),
	  "[备忘]": com("E301"),
	  "[秘密]": com("E315"),
	  "[男人]": com("E138"),
	  "[女人]": com("E139")
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * 消息发送状态
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__(1);
	
	__webpack_require__(24);
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MsgStatus = function (_Component) {
		_inherits(MsgStatus, _Component);
	
		function MsgStatus(props) {
			_classCallCheck(this, MsgStatus);
	
			return _possibleConstructorReturn(this, (MsgStatus.__proto__ || Object.getPrototypeOf(MsgStatus)).call(this, props));
		}
	
		_createClass(MsgStatus, [{
			key: 'render',
			value: function render(_ref, state) {
				var status = _ref.status,
				    props = _objectWithoutProperties(_ref, ['status']);
	
				var _style = 'status__' + status;
				var text = status === 'err' ? '!' : '';
	
				return (0, _preact.h)(
					'div',
					{ 'class': ['status', _style].join(' '),
						onClick: this.props.onErrClick },
					text
				);
			}
		}]);
	
		return MsgStatus;
	}(_preact.Component);
	
	exports.default = MsgStatus;

/***/ },
/* 6 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * 接口管理文件
	 */
	
	// 客服
	var KFDomain = 'http://kefu.weidian.com';
	
	var PCClientTrs = '//wd.api.weidian.com';
	var STAFF_SERVICE = 'http://kefu.weidian.com/EliteWebChat/jsp/standard/customer.jsp';
	
	// 获取地址
	var getTicketUrlDev = 'https://gw.test.weidian.com/h5/wd/im/robot/getTicket';
	var getTicketUrl = 'https://gwh5.api.weidian.com/wd/im/robot/getTicket';
	
	// 基础请求地址
	var BaseUrl = 'https://im-pivot.api.weidian.com';
	// const BaseUrl = 'http://im-pivot-old.pre.weidian.com';
	
	exports.KFDomain = KFDomain;
	exports.PCClientTrs = PCClientTrs;
	exports.BaseUrl = BaseUrl;
	exports.STAFF_SERVICE = STAFF_SERVICE;
	exports.getTicketUrlDev = getTicketUrlDev;
	exports.getTicketUrl = getTicketUrl;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__(1);
	
	__webpack_require__(27);
	
	__webpack_require__(18);
	
	var _header = __webpack_require__(11);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _body = __webpack_require__(8);
	
	var _body2 = _interopRequireDefault(_body);
	
	var _footer = __webpack_require__(10);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'render',
	    value: function render(props, state) {
	      return (0, _preact.h)(
	        'div',
	        { 'class': 'app' },
	        (0, _preact.h)(_header2.default, null),
	        (0, _preact.h)(_body2.default, null),
	        (0, _preact.h)(_footer2.default, null)
	      );
	    }
	  }]);
	
	  return App;
	}(_preact.Component);
	
	exports.default = App;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__(1);
	
	__webpack_require__(19);
	
	var _message = __webpack_require__(12);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _sdk = __webpack_require__(2);
	
	var _sdk2 = _interopRequireDefault(_sdk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @description body 组件
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var Body = function (_Component) {
	  _inherits(Body, _Component);
	
	  function Body(props) {
	    _classCallCheck(this, Body);
	
	    var _this = _possibleConstructorReturn(this, (Body.__proto__ || Object.getPrototypeOf(Body)).call(this, props));
	
	    _this.state = {
	      msgList: []
	    };
	    return _this;
	  }
	
	  _createClass(Body, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      this.setState({
	        msgList: this.state.msgList.concat(_sdk2.default.getMsgList())
	      });
	
	      _sdk2.default.onMsgChange(function (msg) {
	        _this2.setState({
	          msgList: _this2.state.msgList.concat(msg)
	        });
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.gotoBottom();
	    }
	  }, {
	    key: 'gotoBottom',
	    value: function gotoBottom() {
	      this.hook.scrollIntoView(); // 滚动到底部
	    }
	  }, {
	    key: 'render',
	    value: function render(props, _ref) {
	      var _this3 = this;
	
	      var msgList = _ref.msgList,
	          state = _objectWithoutProperties(_ref, ['msgList']);
	
	      var nearShowTime = 0;
	
	      var vMessages = msgList.map(function (msg, i) {
	        var showTime = true;
	
	        // 控制时间的展示 间隔 3 分钟
	        if (i === 0) {
	          nearShowTime = msg.time;
	        } else {
	          var dt = msg.time - nearShowTime;
	
	          if (dt > 3 * 60 * 1000) {
	            nearShowTime = msg.time;
	          } else {
	            showTime = false;
	          }
	        }
	
	        return (0, _preact.h)(_message2.default, _extends({}, msg, { showTime: showTime }));
	      });
	
	      return (0, _preact.h)(
	        'div',
	        { 'class': 'app__body' },
	        vMessages,
	        (0, _preact.h)('div', { ref: function ref(_ref2) {
	            _this3.hook = _ref2;
	          } })
	      );
	    }
	  }]);
	
	  return Body;
	}(_preact.Component);
	
	exports.default = Body;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__(1);
	
	var _emojiMap = __webpack_require__(4);
	
	var _emojiMap2 = _interopRequireDefault(_emojiMap);
	
	__webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 表情组件
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var Face = function (_Component) {
	  _inherits(Face, _Component);
	
	  function Face(props) {
	    _classCallCheck(this, Face);
	
	    return _possibleConstructorReturn(this, (Face.__proto__ || Object.getPrototypeOf(Face)).call(this, props));
	  }
	
	  _createClass(Face, [{
	    key: 'render',
	    value: function render(props, state) {
	      var vFaceItem = [];
	
	      var _loop = function _loop(key) {
	        vFaceItem.push((0, _preact.h)(
	          'li',
	          {
	            'class': 'face__item',
	            title: key.slice(1, -1),
	            onClick: function onClick() {
	              props.onChoose && props.onChoose(key);
	            }
	          },
	          (0, _preact.h)('img', { src: _emojiMap2.default[key], alt: 'face' })
	        ));
	      };
	
	      for (var key in _emojiMap2.default) {
	        _loop(key);
	      }
	      return (0, _preact.h)(
	        'div',
	        {
	          'class': [props.class, 'face__wrap'].join(' '),
	          title: '',
	          style: {
	            display: !!props.show ? 'block' : 'none'
	          }
	        },
	        (0, _preact.h)(
	          'ul',
	          { 'class': 'face__wrap--panel' },
	          vFaceItem
	        ),
	        (0, _preact.h)(
	          'span',
	          { 'class': 'face__wrap--arrow' },
	          'arrow'
	        )
	      );
	    }
	  }]);
	
	  return Face;
	}(_preact.Component);
	
	exports.default = Face;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__(1);
	
	__webpack_require__(21);
	
	var _face = __webpack_require__(9);
	
	var _face2 = _interopRequireDefault(_face);
	
	var _emojiMap = __webpack_require__(4);
	
	var _emojiMap2 = _interopRequireDefault(_emojiMap);
	
	var _sdk = __webpack_require__(2);
	
	var _sdk2 = _interopRequireDefault(_sdk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @description 底部组件
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var MAX_VALUE_NUM = 200;
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer(props) {
	    _classCallCheck(this, Footer);
	
	    var _this = _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));
	
	    _this.state = {
	      value: '',
	      valueNum: 0,
	      faces: []
	    };
	    return _this;
	  }
	
	  _createClass(Footer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      window.addEventListener('keyup', this.handleKeyUp.bind(this));
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('keyup', this.handleKeyUp);
	    }
	  }, {
	    key: 'sendMsg',
	    value: function sendMsg() {
	      if (this.state.valueNum > 200) {
	        return;
	      }
	
	      var endReg = /\s*\<br\s*\/\>\s*$/; //去掉末尾的空格和br标签
	      var startReg = /^\s*/; // 去掉开始的空格
	      var msg = this.state.value.replace(startReg, '').replace(endReg, '').replace(/\n$/, '');
	
	      this.setState({
	        value: '',
	        valueNum: 0,
	        showFace: false
	      });
	
	      if (!msg) {
	        return;
	      }
	
	      _sdk2.default.appendMsg(msg);
	    }
	  }, {
	    key: 'handleFaceChoose',
	    value: function handleFaceChoose(value) {
	      var _this2 = this;
	
	      var str = this.state.value + value;
	
	      this.setState({
	        value: str,
	        // faces: this.state.faces.concat(value),
	        valueNum: this.state.valueNum + 1
	      }, function () {
	        _this2.TEXT_AREA.focus();
	      });
	    }
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(ev) {
	
	      if (ev.keyCode === 8) {
	        this.preValue = this.state.value;
	      }
	    }
	  }, {
	    key: 'handleKeyUp',
	    value: function handleKeyUp(ev) {
	      var value = this.state.value;
	
	      if (ev.keyCode === 8) {
	        if (this.preValue === this.state.value || !value) {
	          return;
	        }
	
	        var valObj = this.checkValue(this.preValue);
	
	        if (valObj.result !== this.preValue) {
	          // let faces = [].concat(this.state.faces);
	          // let index = faces.indexOf(valObj.face);
	
	          // if(index !== -1){
	          //   faces.splice(index,1);
	          // }
	
	          this.setState({
	            value: valObj.result
	            // faces: faces
	          });
	        }
	      }
	
	      // 回车发送消息
	      if (ev.keyCode === 13 && !ev.shiftKey) {
	        this.sendMsg();
	      }
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput(ev) {
	      var value = ev.target.value;
	      var faces = this.calcFace();
	      var num = value.length - faces.join('').length + faces.length;
	
	      this.setState({
	        value: value,
	        valueNum: num
	      });
	    }
	  }, {
	    key: 'handleFoucs',
	    value: function handleFoucs() {
	      var obj = this.TEXT_AREA,
	          pos = this.state.value.length;
	
	      if (obj.createTextRange) {
	        //IE浏览器 IE浏览器中有TextRange  对body,textarea,button有效
	        var range = obj.createTextRange(); //创建textRange
	        range.moveStart("character", pos); //移动开始点，以字符为单位
	        range.collapse(true); //没有移动结束点直接 折叠到一个点
	        range.select(); //选择这个点
	      } else {
	        //非IE浏览器
	        obj.setSelectionRange(obj.value.length, pos);
	      }
	
	      obj.focus();
	    }
	  }, {
	    key: 'calcFace',
	    value: function calcFace() {
	      var reg = /(\[.*?\])/g;
	      var matchArr = this.state.value.match(reg);
	      var result = [];
	
	      if (matchArr) {
	        result = matchArr.filter(function (item) {
	          if (_emojiMap2.default[item]) {
	            return true;
	          }
	
	          return false;
	        });
	      }
	
	      return result;
	    }
	    /**
	    * @description 检查末尾是否有表情如果有返回删除最后一个表情的字符串没有则返回传参
	    */
	
	  }, {
	    key: 'checkValue',
	    value: function checkValue(value) {
	      var result = value;
	      var emoji = '';
	
	      if (value && value.slice(-1) === ']') {
	        var delIcon = /(\[.*?\])/g;
	        var tempArr = value.match(delIcon);
	
	        if (tempArr && tempArr.length > 0) {
	          emoji = tempArr.slice(-1).toString();
	
	          if (_emojiMap2.default[emoji]) {
	            result = value.slice(0, -emoji.length);
	          } else {
	            emoji = '';
	          }
	        }
	      }
	
	      return {
	        result: result,
	        face: emoji
	      };
	    }
	  }, {
	    key: 'vTip',
	    value: function vTip() {
	      var diffNum = MAX_VALUE_NUM - this.state.valueNum;
	
	      if (diffNum >= 0) {
	        return (0, _preact.h)(
	          'span',
	          { 'class': 'footer__options--tip' },
	          '\u8FD8\u53EF\u8F93\u5165',
	          diffNum,
	          '\u5B57'
	        );
	      } else {
	        return (0, _preact.h)(
	          'span',
	          { 'class': 'footer__options--wram' },
	          '\u5DF2\u8D85\u8FC7',
	          -diffNum,
	          '\u5B57'
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render(props, state) {
	      var _this3 = this;
	
	      return (0, _preact.h)(
	        'footer',
	        { 'class': 'app__footer' },
	        (0, _preact.h)(
	          'div',
	          { 'class': 'footer__tool' },
	          (0, _preact.h)(
	            'div',
	            {
	              'class': 'footer__tool--icon footer__tool--face',
	              title: '\u8868\u60C5',
	              onClick: function onClick() {
	                _this3.setState({
	                  showFace: !state.showFace
	                });
	              }
	            },
	            (0, _preact.h)(_face2.default, {
	              show: state.showFace,
	              'class': 'footer__face',
	              onChoose: this.handleFaceChoose.bind(this)
	            }),
	            '\u8868\u60C5'
	          ),
	          (0, _preact.h)(
	            'span',
	            {
	              'class': 'footer__tool--icon footer__tool--staff',
	              title: '\u4EBA\u5DE5\u670D\u52A1',
	              onClick: function onClick() {
	                _sdk2.default.gotoStaffService();
	              }
	            },
	            '\u4EBA\u5DE5'
	          )
	        ),
	        (0, _preact.h)(
	          'div',
	          { 'class': 'footer__edit' },
	          (0, _preact.h)('textarea', {
	            ref: function ref(_ref) {
	              _this3.TEXT_AREA = _ref;
	            },
	            'class': 'footer__edit--input',
	            value: state.value,
	            onKeyUp: this.handleKeyUp.bind(this),
	            onKeyDown: this.handleKeyDown.bind(this),
	            onInput: this.handleInput.bind(this),
	            onFocus: this.handleFoucs.bind(this)
	          })
	        ),
	        (0, _preact.h)(
	          'div',
	          { 'class': 'footer__options' },
	          this.vTip(),
	          (0, _preact.h)(
	            'span',
	            {
	              'class': 'footer__options--btn',
	              onClick: this.sendMsg.bind(this)
	            },
	            '\u53D1\u9001'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Footer;
	}(_preact.Component);
	
	exports.default = Footer;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _preact = __webpack_require__(1);
	
	__webpack_require__(22);
	
	/**
	 * @description header component
	 */
	
	exports.default = function (props) {
	  return (0, _preact.h)('header', { 'class': 'app__header' });
	};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__(1);
	
	__webpack_require__(23);
	
	var _receiveWrap = __webpack_require__(13);
	
	var _receiveWrap2 = _interopRequireDefault(_receiveWrap);
	
	var _sendWrap = __webpack_require__(14);
	
	var _sendWrap2 = _interopRequireDefault(_sendWrap);
	
	var _sdk = __webpack_require__(2);
	
	var _sdk2 = _interopRequireDefault(_sdk);
	
	var _util = __webpack_require__(3);
	
	var _emojiMap = __webpack_require__(4);
	
	var _emojiMap2 = _interopRequireDefault(_emojiMap);
	
	var _msgStatus = __webpack_require__(5);
	
	var _msgStatus2 = _interopRequireDefault(_msgStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 消息组件
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var ROLE_WRAP = {
	  'send': _sendWrap2.default,
	  'receive': _receiveWrap2.default
	};
	
	var Message = function (_Component) {
	  _inherits(Message, _Component);
	
	  function Message(props) {
	    _classCallCheck(this, Message);
	
	    var _this = _possibleConstructorReturn(this, (Message.__proto__ || Object.getPrototypeOf(Message)).call(this, props));
	
	    _this.state = {
	      tipName: 'isHelp',
	      status: props.isStorage ? 'complete' : 'loading'
	    };
	    return _this;
	  }
	
	  _createClass(Message, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.props.isStorage) {
	        this.sendMsg();
	      }
	    }
	  }, {
	    key: 'sendMsg',
	    value: function sendMsg() {
	      var _this2 = this;
	
	      this.setState({
	        status: 'loading'
	      });
	
	      // 发送前做表情解析
	      var msg = (0, _util.parseFace)(_emojiMap2.default, this.props.msgData);
	
	      _sdk2.default.send(msg, function (err, status) {
	        if (err) {
	          return _this2.setState({
	            status: 'err'
	          });
	        };
	
	        if (status.status_code === 0) {
	          _this2.setState({
	            status: 'complete'
	          });
	        } else {
	          _this2.setState({
	            status: 'err'
	          });
	        }
	      });
	    }
	  }, {
	    key: 'sendQuestion',
	    value: function sendQuestion(question) {
	      _sdk2.default.appendMsg(question);
	    }
	  }, {
	    key: 'sendFeedback',
	    value: function sendFeedback(value) {
	      if (value === 1) {
	        this.setState({
	          tipName: 'thanks'
	        });
	      } else {
	        this.setState({
	          tipName: 'sorry'
	        });
	      }
	
	      _sdk2.default.feedBack(this.props.msgId, value);
	    }
	  }, {
	    key: 'vOnline',
	    value: function vOnline() {
	      return (0, _preact.h)(
	        'span',
	        {
	          'class': 'online__service--link',
	          onClick: function onClick() {
	            _sdk2.default.gotoStaffService();
	          }
	        },
	        '\u4EBA\u5DE5\u670D\u52A1'
	      );
	    }
	  }, {
	    key: 'vFeedback',
	    value: function vFeedback() {
	      if (this.state.tipName === 'isHelp') {
	        return (0, _preact.h)(
	          'div',
	          { 'class': 'msg__options--list' },
	          (0, _preact.h)(
	            'span',
	            { 'class': 'msg__options--item', onClick: this.sendFeedback.bind(this, 1) },
	            '\u6709\u5E2E\u52A9'
	          ),
	          (0, _preact.h)(
	            'span',
	            { 'class': 'msg__options--item', onClick: this.sendFeedback.bind(this, -1) },
	            '\u6CA1\u5E2E\u52A9'
	          )
	        );
	      }
	    }
	  }, {
	    key: 'vTime',
	    value: function vTime(time) {
	      return (0, _preact.h)(
	        'p',
	        { 'class': 'msg__time' },
	        (0, _util.getLocalTime)(+time)
	      );
	    }
	  }, {
	    key: 'vContent',
	    value: function vContent(msg, overturn) {
	      if (!msg && overturn === 1) {
	        return (0, _preact.h)(
	          'p',
	          { 'class': 'msg__content' },
	          '\u60A8\u597D\uFF0C\u4F60\u7684\u95EE\u9898\u6682\u672A\u627E\u5230\u7B54\u6848\uFF0C\u8BF7\u66F4\u6362\u63CF\u8FF0\u91CD\u8BD5\uFF0C\u6216\u5207\u6362\u4E3A',
	          this.vOnline()
	        );
	      }
	
	      // 格式处理
	      msg = msg.replace(/\n/g, " <br /> ");
	      msg = msg.replace(/\[br\]/g, ' <br/> ');
	
	      // 做表情解析
	      msg = (0, _util.parseFace)(_emojiMap2.default, msg);
	
	      return (0, _preact.h)('p', { 'class': 'msg__content', dangerouslySetInnerHTML: { __html: msg } });
	    }
	  }, {
	    key: 'vOtherAnswer',
	    value: function vOtherAnswer(detail) {
	      var _this3 = this;
	
	      if (!detail || detail.similarQuestion.length === 0) {
	        return;
	      }
	
	      return (0, _preact.h)(
	        'section',
	        { 'class': 'msg__other--wrap' },
	        (0, _preact.h)(
	          'h2',
	          { 'class': 'msg__other--title' },
	          '\u70B9\u51FB\u53EF\u4E86\u89E3\u66F4\u591A\u95EE\u9898\uFF1A'
	        ),
	        (0, _preact.h)(
	          'ul',
	          { 'class': 'msg__other--list' },
	          detail.similarQuestion.map(function (item) {
	            return (0, _preact.h)(
	              'li',
	              { 'class': 'msg__ohter--item' },
	              (0, _preact.h)(
	                'span',
	                { onClick: _this3.sendQuestion.bind(_this3, item) },
	                item
	              )
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: 'vSeedback',
	    value: function vSeedback(needFeedback) {
	      // 1 需要 0 不需要
	      if (needFeedback === 0) {
	        return;
	      }
	
	      var tips = {
	        sorry: '如未能解决问题，请您更换问题描述或切换到',
	        thanks: '感谢您对小微的支持。',
	        isHelp: '小微是否有帮到你？'
	      };
	
	      return (0, _preact.h)(
	        'footer',
	        { 'class': 'msg__options' },
	        (0, _preact.h)(
	          'p',
	          null,
	          tips[this.state.tipName],
	          this.state.tipName === 'sorry' && this.vOnline()
	        ),
	        this.vFeedback()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render(props, state) {
	      var Wrap = ROLE_WRAP[props.role];
	
	      return (0, _preact.h)(
	        'div',
	        { 'class': 'message' },
	        props.showTime && this.vTime(props.time),
	        (0, _preact.h)(
	          Wrap,
	          {
	            session: props.session,
	            status: state.status,
	            onErrClick: this.sendMsg.bind(this)
	          },
	          this.vContent(props.msgData, props.overturn),
	          this.vOtherAnswer(props.detail),
	          this.vSeedback(props.needFeedback)
	        )
	      );
	    }
	  }]);
	
	  return Message;
	}(_preact.Component);
	
	exports.default = Message;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _preact = __webpack_require__(1);
	
	__webpack_require__(25);
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * @description 接受消息外壳组件
	                                                                                                                                                                                                                              */
	
	exports.default = function (_ref) {
	  var children = _ref.children,
	      session = _ref.session,
	      props = _objectWithoutProperties(_ref, ['children', 'session']);
	
	  var src = 'https://si.geilicdn.com/vshop952769023-wholesale-apply-1488194077393.jpg?w=150&h=150&cp=1';
	
	  return (0, _preact.h)(
	    'div',
	    { 'class': 'msg__rwrap' },
	    (0, _preact.h)('img', { src: session.portrait, alt: 'portrait', 'class': 'msg__rwrap--portrait' }),
	    (0, _preact.h)(
	      'div',
	      { 'class': 'msg__rwrap--content' },
	      (0, _preact.h)('span', { 'class': 'msg__left--icon' }),
	      children
	    )
	  );
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _preact = __webpack_require__(1);
	
	__webpack_require__(26);
	
	var _msgStatus = __webpack_require__(5);
	
	var _msgStatus2 = _interopRequireDefault(_msgStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * @description 发送消息外壳组件
	                                                                                                                                                                                                                              */
	
	exports.default = function (_ref) {
	  var children = _ref.children,
	      session = _ref.session,
	      props = _objectWithoutProperties(_ref, ['children', 'session']);
	
	  return (0, _preact.h)(
	    'div',
	    { 'class': 'msg__swrap' },
	    (0, _preact.h)(_msgStatus2.default, {
	      status: props.status,
	      onErrClick: props.onErrClick
	    }),
	    (0, _preact.h)(
	      'div',
	      { 'class': 'msg__swrap--content' },
	      (0, _preact.h)('span', { 'class': 'msg__right--icon' }),
	      children
	    ),
	    (0, _preact.h)('img', { src: session.portrait, alt: 'portrait', 'class': 'msg__swrap--portrait' })
	  );
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (ruleName, params, fn) {
		var rule = _request2.default[ruleName]();
	
		return (0, _reqwest2.default)({
			url: rule.url,
			method: rule.method || 'GET',
			data: rule.formatRule(params),
			type: rule.type || 'json',
			crossOrigin: true,
			withCredentials: true,
			timeout: 10000,
			success: function success(response) {
				if (fn && typeof fn === 'function') {
					fn(null, response);
				}
			},
			complete: function complete(response) {
				console.log('response', ruleName, response);
			},
	
			error: function error(err) {
				fn && fn(new Error(ruleName + '请求失败'), null);
			}
		});
	};
	
	var _reqwest = __webpack_require__(32);
	
	var _reqwest2 = _interopRequireDefault(_reqwest);
	
	var _request = __webpack_require__(16);
	
	var _request2 = _interopRequireDefault(_request);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _request = __webpack_require__(6);
	
	var urls = _interopRequireWildcard(_request);
	
	var _util = __webpack_require__(3);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * 请求封装
	 */
	var sessionId = util.getSessionId();
	var clientInfo = JSON.stringify({
		sourceType: 1001
	});
	
	exports.default = {
		sendFeedBack: function sendFeedBack() {
			return {
				url: urls.BaseUrl + '/autoCustom/sendFeedback',
				method: 'POST',
				formatRule: function formatRule(params) {
					return {
						clientInfo: clientInfo,
						userId: params.bid,
						from: params.sourceType,
						channel: params.channel,
						sessionId: sessionId, //会话session id，每次新打开客服聊天页面，创建一个随机session id
						feedbackId: params.msgId, //机器人客服消息id
						result: params.result //反馈内容 0-有用 1－没用
					};
				}
			};
		},
		sendMessage: function sendMessage() {
			return {
				url: urls.BaseUrl + '/autoCustom/sendQuestion',
				method: 'POST',
				formatRule: function formatRule(params) {
					return {
						from: params.sourceType,
						clientInfo: clientInfo,
						userId: params.bid,
						channel: params.channel,
						sessionId: sessionId, //会话session id，每次新打开客服聊天页面，创建一个随机session id
						question: params.question //消息内容
					};
				}
			};
		},
		getUserInfo: function getUserInfo() {
			return {
				url: urls.BaseUrl + '/follow/info/getInfosBySid',
				type: 'jsonp',
				formatRule: function formatRule(params) {
					return {
						sids: params.sids,
						clientInfo: clientInfo,
						role: 'seller',
						sid: params.bid
					};
				}
			};
		},
	
	
		// getServiceUrl() {
		// 	return {
		// 		url: urls.PCClientTrs + '/wd/seller/verify/getTicket',
		// 		formatRule: function (params) {
		// 			return {
		// 				param: JSON.stringify({
		// 					"userID": params.userID,
		// 					"wduss": params.wduss
		// 				})
		// 			}
		// 		}
		// 	}
		// },
	
		getTicket: function getTicket() {
			var getTicketUrl = urls.getTicketUrl;
	
	
			return {
				url: getTicketUrl,
				type: 'jsonp',
				formatRule: function formatRule(uid) {
					return {
						uid: uid,
						bizType: 'service',
						param: JSON.stringify({})
					};
				}
			};
		}
	};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.ajustTime = ajustTime;
	exports.isWorkTime = isWorkTime;
	exports.isDouble11WorkTime = isDouble11WorkTime;
	exports.isDouble11 = isDouble11;
	exports.isSpringWorkTime = isSpringWorkTime;
	exports.isSpringFestival = isSpringFestival;
	exports.getDouble11WorkTime = getDouble11WorkTime;
	
	var _timeFormater = __webpack_require__(34);
	
	var _timeFormater2 = _interopRequireDefault(_timeFormater);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var workTime = { startTime: 9, endTime: 21 };
	var springWorkTime = { startTime: 9, endTime: 18 };
	var springFestivalTime = { startTime: '2018/2/8 21:00', endTime: '2018/2/21 21:00' };
	
	var d11Rang = {
		'11/10': [{ startTime: 9, endTime: 24 }],
		'11/11': [{ startTime: 0, endTime: 2 }, { startTime: 9, endTime: 24 }]
	};
	
	var timeDiff = 0;
	
	function getMonthDateStr() {
		var now = new Date();
		return now.getMonth() + 1 + '/' + now.getDate();
	}
	
	function getServerDate() {
		var xhr = null;
	
		if (window.XMLHttpRequest) {
			xhr = new window.XMLHttpRequest();
		} else {
			// ie
			xhr = new ActiveObject("Microsoft");
		}
	
		xhr.open("GET", "/", false); //false不可变
		xhr.send(null);
		var date = xhr.getResponseHeader("Date");
	
		return new Date(date);
	}
	
	function ajustTime() {
		var serviceTime = +getServerDate();
		var localTime = +new Date();
	
		var diff = serviceTime - localTime;
	
		console.log('与服务器相差', diff);
		console.log(serviceTime);
	
		// 允许 5000 ms 的差异
		if (diff > 0 && Math.abs(diff) > 5000) {
			timeDiff = serviceTime - localTime;
		}
	}
	
	function getDateTime() {
		return +new Date() + timeDiff;
	}
	
	function isInWork(work) {
		var dt = (0, _timeFormater2.default)(new Date(getDateTime()));
		var hour = +dt.format('H');
	
		if (hour < work.startTime) {
			return false;
		}
	
		if (hour >= work.endTime) {
			return false;
		}
	
		return true;
	}
	
	function isInDouble11Work(works) {
		var inWorkTime = false;
		if (Array.isArray(works)) {
			for (var i = 0; i < works.length; i++) {
				if (!inWorkTime) {
					inWorkTime = isInWork(works[i]);
				}
			}
		}
		return inWorkTime;
	}
	
	function isWorkTime() {
		return isInWork(workTime);
	}
	function isDouble11WorkTime() {
		var d11workTime = getDouble11WorkTime();
		if (d11workTime) {
			return isInDouble11Work(d11workTime);
		}
		return true;
	}
	
	function isDouble11() {
		var d11workTime = getDouble11WorkTime();
		if (d11workTime) {
			return true;
		}
		return false;
	}
	
	function isSpringWorkTime() {
		if (isSpringFestival()) {
			return isInWork(springWorkTime);
		}
	
		return true;
	}
	
	function isSpringFestival() {
		var n = getDateTime();
		var s = +new Date(springFestivalTime.startTime);
		var e = +new Date(springFestivalTime.endTime);
	
		return n >= s && n <= e;
	}
	function getDouble11WorkTime() {
	
		var n = getMonthDateStr();
	
		return d11Rang[n];
	}

/***/ },
/* 18 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 19 */
18,
/* 20 */
18,
/* 21 */
18,
/* 22 */
18,
/* 23 */
18,
/* 24 */
18,
/* 25 */
18,
/* 26 */
18,
/* 27 */
18,
/* 28 */
/***/ function(module, exports) {

	'use strict';
	var token = '%[a-f0-9]{2}';
	var singleMatcher = new RegExp(token, 'gi');
	var multiMatcher = new RegExp('(' + token + ')+', 'gi');
	
	function decodeComponents(components, split) {
		try {
			// Try to decode the entire string first
			return decodeURIComponent(components.join(''));
		} catch (err) {
			// Do nothing
		}
	
		if (components.length === 1) {
			return components;
		}
	
		split = split || 1;
	
		// Split the array in 2 parts
		var left = components.slice(0, split);
		var right = components.slice(split);
	
		return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
	}
	
	function decode(input) {
		try {
			return decodeURIComponent(input);
		} catch (err) {
			var tokens = input.match(singleMatcher);
	
			for (var i = 1; i < tokens.length; i++) {
				input = decodeComponents(tokens, i).join('');
	
				tokens = input.match(singleMatcher);
			}
	
			return input;
		}
	}
	
	function customDecodeURIComponent(input) {
		// Keep track of all the replacements and prefill the map with the `BOM`
		var replaceMap = {
			'%FE%FF': '\uFFFD\uFFFD',
			'%FF%FE': '\uFFFD\uFFFD'
		};
	
		var match = multiMatcher.exec(input);
		while (match) {
			try {
				// Decode as big chunks as possible
				replaceMap[match[0]] = decodeURIComponent(match[0]);
			} catch (err) {
				var result = decode(match[0]);
	
				if (result !== match[0]) {
					replaceMap[match[0]] = result;
				}
			}
	
			match = multiMatcher.exec(input);
		}
	
		// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
		replaceMap['%C2'] = '\uFFFD';
	
		var entries = Object.keys(replaceMap);
	
		for (var i = 0; i < entries.length; i++) {
			// Replace all decoded components
			var key = entries[i];
			input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
		}
	
		return input;
	}
	
	module.exports = function (encodedURI) {
		if (typeof encodedURI !== 'string') {
			throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
		}
	
		try {
			encodedURI = encodedURI.replace(/\+/g, ' ');
	
			// Try the built in decoder first
			return decodeURIComponent(encodedURI);
		} catch (err) {
			// Fallback to a more advanced decoder
			return customDecodeURIComponent(encodedURI);
		}
	};


/***/ },
/* 29 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 30 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(33);
	var objectAssign = __webpack_require__(30);
	var decodeComponent = __webpack_require__(28);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeComponent(val);
	
			formatter(decodeComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  * Reqwest! A general purpose XHR connection manager
	  * license MIT (c) Dustin Diaz 2015
	  * https://github.com/ded/reqwest
	  */
	
	!function (name, context, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  else context[name] = definition()
	}('reqwest', this, function () {
	
	  var context = this
	
	  if ('window' in context) {
	    var doc = document
	      , byTag = 'getElementsByTagName'
	      , head = doc[byTag]('head')[0]
	  } else {
	    var XHR2
	    try {
	      XHR2 = __webpack_require__(36)
	    } catch (ex) {
	      throw new Error('Peer dependency `xhr2` required! Please npm install xhr2')
	    }
	  }
	
	
	  var httpsRe = /^http/
	    , protocolRe = /(^\w+):\/\//
	    , twoHundo = /^(20\d|1223)$/ //http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	    , readyState = 'readyState'
	    , contentType = 'Content-Type'
	    , requestedWith = 'X-Requested-With'
	    , uniqid = 0
	    , callbackPrefix = 'reqwest_' + (+new Date())
	    , lastValue // data stored by the most recent JSONP callback
	    , xmlHttpRequest = 'XMLHttpRequest'
	    , xDomainRequest = 'XDomainRequest'
	    , noop = function () {}
	
	    , isArray = typeof Array.isArray == 'function'
	        ? Array.isArray
	        : function (a) {
	            return a instanceof Array
	          }
	
	    , defaultHeaders = {
	          'contentType': 'application/x-www-form-urlencoded'
	        , 'requestedWith': xmlHttpRequest
	        , 'accept': {
	              '*':  'text/javascript, text/html, application/xml, text/xml, */*'
	            , 'xml':  'application/xml, text/xml'
	            , 'html': 'text/html'
	            , 'text': 'text/plain'
	            , 'json': 'application/json, text/javascript'
	            , 'js':   'application/javascript, text/javascript'
	          }
	      }
	
	    , xhr = function(o) {
	        // is it x-domain
	        if (o['crossOrigin'] === true) {
	          var xhr = context[xmlHttpRequest] ? new XMLHttpRequest() : null
	          if (xhr && 'withCredentials' in xhr) {
	            return xhr
	          } else if (context[xDomainRequest]) {
	            return new XDomainRequest()
	          } else {
	            throw new Error('Browser does not support cross-origin requests')
	          }
	        } else if (context[xmlHttpRequest]) {
	          return new XMLHttpRequest()
	        } else if (XHR2) {
	          return new XHR2()
	        } else {
	          return new ActiveXObject('Microsoft.XMLHTTP')
	        }
	      }
	    , globalSetupOptions = {
	        dataFilter: function (data) {
	          return data
	        }
	      }
	
	  function succeed(r) {
	    var protocol = protocolRe.exec(r.url)
	    protocol = (protocol && protocol[1]) || context.location.protocol
	    return httpsRe.test(protocol) ? twoHundo.test(r.request.status) : !!r.request.response
	  }
	
	  function handleReadyState(r, success, error) {
	    return function () {
	      // use _aborted to mitigate against IE err c00c023f
	      // (can't read props on aborted request objects)
	      if (r._aborted) return error(r.request)
	      if (r._timedOut) return error(r.request, 'Request is aborted: timeout')
	      if (r.request && r.request[readyState] == 4) {
	        r.request.onreadystatechange = noop
	        if (succeed(r)) success(r.request)
	        else
	          error(r.request)
	      }
	    }
	  }
	
	  function setHeaders(http, o) {
	    var headers = o['headers'] || {}
	      , h
	
	    headers['Accept'] = headers['Accept']
	      || defaultHeaders['accept'][o['type']]
	      || defaultHeaders['accept']['*']
	
	    var isAFormData = typeof FormData !== 'undefined' && (o['data'] instanceof FormData);
	    // breaks cross-origin requests with legacy browsers
	    if (!o['crossOrigin'] && !headers[requestedWith]) headers[requestedWith] = defaultHeaders['requestedWith']
	    if (!headers[contentType] && !isAFormData) headers[contentType] = o['contentType'] || defaultHeaders['contentType']
	    for (h in headers)
	      headers.hasOwnProperty(h) && 'setRequestHeader' in http && http.setRequestHeader(h, headers[h])
	  }
	
	  function setCredentials(http, o) {
	    if (typeof o['withCredentials'] !== 'undefined' && typeof http.withCredentials !== 'undefined') {
	      http.withCredentials = !!o['withCredentials']
	    }
	  }
	
	  function generalCallback(data) {
	    lastValue = data
	  }
	
	  function urlappend (url, s) {
	    return url + (/\?/.test(url) ? '&' : '?') + s
	  }
	
	  function handleJsonp(o, fn, err, url) {
	    var reqId = uniqid++
	      , cbkey = o['jsonpCallback'] || 'callback' // the 'callback' key
	      , cbval = o['jsonpCallbackName'] || reqwest.getcallbackPrefix(reqId)
	      , cbreg = new RegExp('((^|\\?|&)' + cbkey + ')=([^&]+)')
	      , match = url.match(cbreg)
	      , script = doc.createElement('script')
	      , loaded = 0
	      , isIE10 = navigator.userAgent.indexOf('MSIE 10.0') !== -1
	
	    if (match) {
	      if (match[3] === '?') {
	        url = url.replace(cbreg, '$1=' + cbval) // wildcard callback func name
	      } else {
	        cbval = match[3] // provided callback func name
	      }
	    } else {
	      url = urlappend(url, cbkey + '=' + cbval) // no callback details, add 'em
	    }
	
	    context[cbval] = generalCallback
	
	    script.type = 'text/javascript'
	    script.src = url
	    script.async = true
	    if (typeof script.onreadystatechange !== 'undefined' && !isIE10) {
	      // need this for IE due to out-of-order onreadystatechange(), binding script
	      // execution to an event listener gives us control over when the script
	      // is executed. See http://jaubourg.net/2010/07/loading-script-as-onclick-handler-of.html
	      script.htmlFor = script.id = '_reqwest_' + reqId
	    }
	
	    script.onload = script.onreadystatechange = function () {
	      if ((script[readyState] && script[readyState] !== 'complete' && script[readyState] !== 'loaded') || loaded) {
	        return false
	      }
	      script.onload = script.onreadystatechange = null
	      script.onclick && script.onclick()
	      // Call the user callback with the last value stored and clean up values and scripts.
	      fn(lastValue)
	      lastValue = undefined
	      head.removeChild(script)
	      loaded = 1
	    }
	
	    // Add the script to the DOM head
	    head.appendChild(script)
	
	    // Enable JSONP timeout
	    return {
	      abort: function () {
	        script.onload = script.onreadystatechange = null
	        err({}, 'Request is aborted: timeout', {})
	        lastValue = undefined
	        head.removeChild(script)
	        loaded = 1
	      }
	    }
	  }
	
	  function getRequest(fn, err) {
	    var o = this.o
	      , method = (o['method'] || 'GET').toUpperCase()
	      , url = typeof o === 'string' ? o : o['url']
	      // convert non-string objects to query-string form unless o['processData'] is false
	      , data = (o['processData'] !== false && o['data'] && typeof o['data'] !== 'string')
	        ? reqwest.toQueryString(o['data'])
	        : (o['data'] || null)
	      , http
	      , sendWait = false
	
	    // if we're working on a GET request and we have data then we should append
	    // query string to end of URL and not post data
	    if ((o['type'] == 'jsonp' || method == 'GET') && data) {
	      url = urlappend(url, data)
	      data = null
	    }
	
	    if (o['type'] == 'jsonp') return handleJsonp(o, fn, err, url)
	
	    // get the xhr from the factory if passed
	    // if the factory returns null, fall-back to ours
	    http = (o.xhr && o.xhr(o)) || xhr(o)
	
	    http.open(method, url, o['async'] === false ? false : true)
	    setHeaders(http, o)
	    setCredentials(http, o)
	    if (context[xDomainRequest] && http instanceof context[xDomainRequest]) {
	        http.onload = fn
	        http.onerror = err
	        // NOTE: see
	        // http://social.msdn.microsoft.com/Forums/en-US/iewebdevelopment/thread/30ef3add-767c-4436-b8a9-f1ca19b4812e
	        http.onprogress = function() {}
	        sendWait = true
	    } else {
	      http.onreadystatechange = handleReadyState(this, fn, err)
	    }
	    o['before'] && o['before'](http)
	    if (sendWait) {
	      setTimeout(function () {
	        http.send(data)
	      }, 200)
	    } else {
	      http.send(data)
	    }
	    return http
	  }
	
	  function Reqwest(o, fn) {
	    this.o = o
	    this.fn = fn
	
	    init.apply(this, arguments)
	  }
	
	  function setType(header) {
	    // json, javascript, text/plain, text/html, xml
	    if (header === null) return undefined; //In case of no content-type.
	    if (header.match('json')) return 'json'
	    if (header.match('javascript')) return 'js'
	    if (header.match('text')) return 'html'
	    if (header.match('xml')) return 'xml'
	  }
	
	  function init(o, fn) {
	
	    this.url = typeof o == 'string' ? o : o['url']
	    this.timeout = null
	
	    // whether request has been fulfilled for purpose
	    // of tracking the Promises
	    this._fulfilled = false
	    // success handlers
	    this._successHandler = function(){}
	    this._fulfillmentHandlers = []
	    // error handlers
	    this._errorHandlers = []
	    // complete (both success and fail) handlers
	    this._completeHandlers = []
	    this._erred = false
	    this._responseArgs = {}
	
	    var self = this
	
	    fn = fn || function () {}
	
	    if (o['timeout']) {
	      this.timeout = setTimeout(function () {
	        timedOut()
	      }, o['timeout'])
	    }
	
	    if (o['success']) {
	      this._successHandler = function () {
	        o['success'].apply(o, arguments)
	      }
	    }
	
	    if (o['error']) {
	      this._errorHandlers.push(function () {
	        o['error'].apply(o, arguments)
	      })
	    }
	
	    if (o['complete']) {
	      this._completeHandlers.push(function () {
	        o['complete'].apply(o, arguments)
	      })
	    }
	
	    function complete (resp) {
	      o['timeout'] && clearTimeout(self.timeout)
	      self.timeout = null
	      while (self._completeHandlers.length > 0) {
	        self._completeHandlers.shift()(resp)
	      }
	    }
	
	    function success (resp) {
	      var type = o['type'] || resp && setType(resp.getResponseHeader('Content-Type')) // resp can be undefined in IE
	      resp = (type !== 'jsonp') ? self.request : resp
	      // use global data filter on response text
	      var filteredResponse = globalSetupOptions.dataFilter(resp.responseText, type)
	        , r = filteredResponse
	      try {
	        resp.responseText = r
	      } catch (e) {
	        // can't assign this in IE<=8, just ignore
	      }
	      if (r) {
	        switch (type) {
	        case 'json':
	          try {
	            resp = context.JSON ? context.JSON.parse(r) : eval('(' + r + ')')
	          } catch (err) {
	            return error(resp, 'Could not parse JSON in response', err)
	          }
	          break
	        case 'js':
	          resp = eval(r)
	          break
	        case 'html':
	          resp = r
	          break
	        case 'xml':
	          resp = resp.responseXML
	              && resp.responseXML.parseError // IE trololo
	              && resp.responseXML.parseError.errorCode
	              && resp.responseXML.parseError.reason
	            ? null
	            : resp.responseXML
	          break
	        }
	      }
	
	      self._responseArgs.resp = resp
	      self._fulfilled = true
	      fn(resp)
	      self._successHandler(resp)
	      while (self._fulfillmentHandlers.length > 0) {
	        resp = self._fulfillmentHandlers.shift()(resp)
	      }
	
	      complete(resp)
	    }
	
	    function timedOut() {
	      self._timedOut = true
	      self.request.abort()
	    }
	
	    function error(resp, msg, t) {
	      resp = self.request
	      self._responseArgs.resp = resp
	      self._responseArgs.msg = msg
	      self._responseArgs.t = t
	      self._erred = true
	      while (self._errorHandlers.length > 0) {
	        self._errorHandlers.shift()(resp, msg, t)
	      }
	      complete(resp)
	    }
	
	    this.request = getRequest.call(this, success, error)
	  }
	
	  Reqwest.prototype = {
	    abort: function () {
	      this._aborted = true
	      this.request.abort()
	    }
	
	  , retry: function () {
	      init.call(this, this.o, this.fn)
	    }
	
	    /**
	     * Small deviation from the Promises A CommonJs specification
	     * http://wiki.commonjs.org/wiki/Promises/A
	     */
	
	    /**
	     * `then` will execute upon successful requests
	     */
	  , then: function (success, fail) {
	      success = success || function () {}
	      fail = fail || function () {}
	      if (this._fulfilled) {
	        this._responseArgs.resp = success(this._responseArgs.resp)
	      } else if (this._erred) {
	        fail(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t)
	      } else {
	        this._fulfillmentHandlers.push(success)
	        this._errorHandlers.push(fail)
	      }
	      return this
	    }
	
	    /**
	     * `always` will execute whether the request succeeds or fails
	     */
	  , always: function (fn) {
	      if (this._fulfilled || this._erred) {
	        fn(this._responseArgs.resp)
	      } else {
	        this._completeHandlers.push(fn)
	      }
	      return this
	    }
	
	    /**
	     * `fail` will execute when the request fails
	     */
	  , fail: function (fn) {
	      if (this._erred) {
	        fn(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t)
	      } else {
	        this._errorHandlers.push(fn)
	      }
	      return this
	    }
	  , 'catch': function (fn) {
	      return this.fail(fn)
	    }
	  }
	
	  function reqwest(o, fn) {
	    return new Reqwest(o, fn)
	  }
	
	  // normalize newline variants according to spec -> CRLF
	  function normalize(s) {
	    return s ? s.replace(/\r?\n/g, '\r\n') : ''
	  }
	
	  function serial(el, cb) {
	    var n = el.name
	      , t = el.tagName.toLowerCase()
	      , optCb = function (o) {
	          // IE gives value="" even where there is no value attribute
	          // 'specified' ref: http://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-862529273
	          if (o && !o['disabled'])
	            cb(n, normalize(o['attributes']['value'] && o['attributes']['value']['specified'] ? o['value'] : o['text']))
	        }
	      , ch, ra, val, i
	
	    // don't serialize elements that are disabled or without a name
	    if (el.disabled || !n) return
	
	    switch (t) {
	    case 'input':
	      if (!/reset|button|image|file/i.test(el.type)) {
	        ch = /checkbox/i.test(el.type)
	        ra = /radio/i.test(el.type)
	        val = el.value
	        // WebKit gives us "" instead of "on" if a checkbox has no value, so correct it here
	        ;(!(ch || ra) || el.checked) && cb(n, normalize(ch && val === '' ? 'on' : val))
	      }
	      break
	    case 'textarea':
	      cb(n, normalize(el.value))
	      break
	    case 'select':
	      if (el.type.toLowerCase() === 'select-one') {
	        optCb(el.selectedIndex >= 0 ? el.options[el.selectedIndex] : null)
	      } else {
	        for (i = 0; el.length && i < el.length; i++) {
	          el.options[i].selected && optCb(el.options[i])
	        }
	      }
	      break
	    }
	  }
	
	  // collect up all form elements found from the passed argument elements all
	  // the way down to child elements; pass a '<form>' or form fields.
	  // called with 'this'=callback to use for serial() on each element
	  function eachFormElement() {
	    var cb = this
	      , e, i
	      , serializeSubtags = function (e, tags) {
	          var i, j, fa
	          for (i = 0; i < tags.length; i++) {
	            fa = e[byTag](tags[i])
	            for (j = 0; j < fa.length; j++) serial(fa[j], cb)
	          }
	        }
	
	    for (i = 0; i < arguments.length; i++) {
	      e = arguments[i]
	      if (/input|select|textarea/i.test(e.tagName)) serial(e, cb)
	      serializeSubtags(e, [ 'input', 'select', 'textarea' ])
	    }
	  }
	
	  // standard query string style serialization
	  function serializeQueryString() {
	    return reqwest.toQueryString(reqwest.serializeArray.apply(null, arguments))
	  }
	
	  // { 'name': 'value', ... } style serialization
	  function serializeHash() {
	    var hash = {}
	    eachFormElement.apply(function (name, value) {
	      if (name in hash) {
	        hash[name] && !isArray(hash[name]) && (hash[name] = [hash[name]])
	        hash[name].push(value)
	      } else hash[name] = value
	    }, arguments)
	    return hash
	  }
	
	  // [ { name: 'name', value: 'value' }, ... ] style serialization
	  reqwest.serializeArray = function () {
	    var arr = []
	    eachFormElement.apply(function (name, value) {
	      arr.push({name: name, value: value})
	    }, arguments)
	    return arr
	  }
	
	  reqwest.serialize = function () {
	    if (arguments.length === 0) return ''
	    var opt, fn
	      , args = Array.prototype.slice.call(arguments, 0)
	
	    opt = args.pop()
	    opt && opt.nodeType && args.push(opt) && (opt = null)
	    opt && (opt = opt.type)
	
	    if (opt == 'map') fn = serializeHash
	    else if (opt == 'array') fn = reqwest.serializeArray
	    else fn = serializeQueryString
	
	    return fn.apply(null, args)
	  }
	
	  reqwest.toQueryString = function (o, trad) {
	    var prefix, i
	      , traditional = trad || false
	      , s = []
	      , enc = encodeURIComponent
	      , add = function (key, value) {
	          // If value is a function, invoke it and return its value
	          value = ('function' === typeof value) ? value() : (value == null ? '' : value)
	          s[s.length] = enc(key) + '=' + enc(value)
	        }
	    // If an array was passed in, assume that it is an array of form elements.
	    if (isArray(o)) {
	      for (i = 0; o && i < o.length; i++) add(o[i]['name'], o[i]['value'])
	    } else {
	      // If traditional, encode the "old" way (the way 1.3.2 or older
	      // did it), otherwise encode params recursively.
	      for (prefix in o) {
	        if (o.hasOwnProperty(prefix)) buildParams(prefix, o[prefix], traditional, add)
	      }
	    }
	
	    // spaces should be + according to spec
	    return s.join('&').replace(/%20/g, '+')
	  }
	
	  function buildParams(prefix, obj, traditional, add) {
	    var name, i, v
	      , rbracket = /\[\]$/
	
	    if (isArray(obj)) {
	      // Serialize array item.
	      for (i = 0; obj && i < obj.length; i++) {
	        v = obj[i]
	        if (traditional || rbracket.test(prefix)) {
	          // Treat each array item as a scalar.
	          add(prefix, v)
	        } else {
	          buildParams(prefix + '[' + (typeof v === 'object' ? i : '') + ']', v, traditional, add)
	        }
	      }
	    } else if (obj && obj.toString() === '[object Object]') {
	      // Serialize object item.
	      for (name in obj) {
	        buildParams(prefix + '[' + name + ']', obj[name], traditional, add)
	      }
	
	    } else {
	      // Serialize scalar item.
	      add(prefix, obj)
	    }
	  }
	
	  reqwest.getcallbackPrefix = function () {
	    return callbackPrefix
	  }
	
	  // jQuery and Zepto compatibility, differences can be remapped here so you can call
	  // .ajax.compat(options, callback)
	  reqwest.compat = function (o, fn) {
	    if (o) {
	      o['type'] && (o['method'] = o['type']) && delete o['type']
	      o['dataType'] && (o['type'] = o['dataType'])
	      o['jsonpCallback'] && (o['jsonpCallbackName'] = o['jsonpCallback']) && delete o['jsonpCallback']
	      o['jsonp'] && (o['jsonpCallback'] = o['jsonp'])
	    }
	    return new Reqwest(o, fn)
	  }
	
	  reqwest.ajaxSetup = function (options) {
	    options = options || {}
	    for (var k in options) {
	      globalSetupOptions[k] = options[k]
	    }
	  }
	
	  return reqwest
	});


/***/ },
/* 33 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(35);

/***/ },
/* 35 */
/***/ function(module, exports) {

	
	var TimeFormater = function (input) {
	  return new TimeFormater.fn.init(input);
	}
	
	TimeFormater.fn = TimeFormater.prototype = {
	  constructor: TimeFormater,
	  init: function (input) {
	    if (typeof input == 'string' || typeof input == 'number') {
	      this[0] = new Date(input);
	    } else if (input instanceof Date) {
	      this[0] = input;
	    } else {
	      this[0] = new Date();
	    }
	    return this;
	  },
	  format: function (str) {
	    var that = this;
	    if (typeof str === 'string') {
	      return str.replace(/Y{4}|M{1,4}|Do|D{1,2}|d{1,4}|Q|H{1,2}|h{1,2}|m{1,2}|s{1,2}|S{1,3}|A|a|x|X/g, function (match) {
	        return that[match] ? that[match]() : match;
	      });
	    } else {
	      return that.toLocaleString();
	    }
	  },
	  fromNow: function () {
	    var oldTime = this[0].getTime();
	    var newTime = Date.now();
	    var diff = parseInt(newTime - oldTime);
	    if (diff < 10000) {
	      return '刚刚';
	    } else if (diff < 60000) {
	      return parseInt(diff / 1000) + '秒前';
	    } else if (diff < 3600000) {
	      return parseInt(diff / 60000) + '分钟前';
	    } else if (diff < 86400000) {
	      return parseInt(diff / 3600000) + '小时前';
	    } else if (diff < 2592000000) {
	      return parseInt(diff / 86400000) + '天前';
	    } else if (diff < 31104000000) {
	      return parseInt(diff / 2592000000) + '月前';
	    } else {
	      return parseInt(diff / 31104000000) + '年前';
	    }
	  },
	  toDouble: function (num) {
	    return num < 10 ? '0' + num : num;
	  },
	  YYYY: function () {
	    return this[0].getFullYear();
	  },
	  Q: function () {
	    return Math.ceil(this.M() / 3);
	  },
	  M: function () {
	    return this[0].getMonth() + 1;
	  },
	  MM: function () {
	    return this.toDouble(this.M());
	  },
	  MMM: function () {
	    return this.M() + '月';
	  },
	  MMMM: function () {
	    var str = '一,二,三,四,五,六,七,八,九,十,十一,十二';
	    return str.split(',')[this.M() - 1] + '月';
	  },
	  D: function () {
	    return this[0].getDate();
	  },
	  Do: function () {
	    return this.D() + '日';
	  },
	  DD: function () {
	    return this.toDouble(this.D());
	  },
	  d: function () {
	    return this[0].getDay();
	  },
	  dd: function () {
	    var str = '日一二三四五六';
	    return str[this.d()];
	  },
	  ddd: function () {
	    return '周' + this.dd();
	  },
	  dddd: function () {
	    return '星期' + this.dd();
	  },
	  H: function () {
	    return this[0].getHours();
	  },
	  HH: function () {
	    return this.toDouble(this.H());
	  },
	  h: function () {
	    var hour = this.H();
	    return hour == 0 ? 12 : hour;
	  },
	  hh: function () {
	    return this.toDouble(this.h());
	  },
	  m: function () {
	    return this[0].getMinutes();
	  },
	  mm: function () {
	    return this.toDouble(this.m());
	  },
	  s: function () {
	    return this[0].getSeconds();
	  },
	  ss: function () {
	    return this.toDouble(this.s());
	  },
	  SSS: function () {
	    return this[0].getMilliseconds();
	  },
	  SS: function () {
	    return parseInt(this.SSS() / 10);
	  },
	  S: function () {
	    return parseInt(this.SS() / 10);
	  },
	  A: function () {
	    var hm = this.H() * 100 + this.m();
	    if (hm < 600) {
	      return '凌晨';
	    } else if (hm < 900) {
	      return '早上';
	    } else if (hm < 1130) {
	      return '上午';
	    } else if (hm < 1230) {
	      return '中午';
	    } else if (hm < 1800) {
	      return '下午';
	    } else {
	      return '晚上';
	    }
	  },
	  a: function () {
	    return this.A();
	  },
	  x: function () {
	    return this[0].getTime();
	  },
	  X: function () {
	    return parseInt(this.x() / 1000);
	  }
	};
	
	TimeFormater.fn.init.prototype = TimeFormater.fn;
	
	module.exports = TimeFormater;

/***/ },
/* 36 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** 8b1c55.app.js
 **/